






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaAryzta} from '@/model/resource/CargaAryzta'
import {InputCargaAryztaSchema} from '@/schema/resource/CargaAryzta/InputCargaAryztaSchema'

@Component
export default class PersistCargaAryztaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaAryztaSchema()
  cargaAryzta = new CargaAryzta()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaAryzta.getCargaAryzta(id)
    }

    $.await.done('getCargaAryzta')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaAryzta.persistCargaAryzta()
    await Helper.successAndPush('system.success.persist', '/carga-aryzta/list')
  }
}
